module.exports = __webpack_public_path__ + "static/img/d-sam.3fdce91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/d-sam.jpg
// module id = 06EC
// module chunks = 95